import { cartActionsStyles } from "@insite/content-library/Widgets/Cart/CartActions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

cartActionsStyles.wideOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
           button {
            background: none !important;
           }
           > ul > li > button {
            color: ${COLORS.primary.base} !important;
           }
        `,
    },
}
cartActionsStyles.addAllToListClickable = {
    css: css`
        color: ${COLORS.primary.base} !important;
        font-family: ${TYPOGRAPHY.fontFamily.title};
        font-size: ${TYPOGRAPHY.size.base};
        font-weight: ${TYPOGRAPHY.weight.mediumbold};
    `,
}
cartActionsStyles.narrowHidden = {
    above: "sm",
    css: css`
    display: flex;
    justify-content: flex-end;
    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                button {
                    background: none !important;
                }
                
                `,
                css`
                button {
                    background: none !important;
                }
                `,
                css`
                button {
                    background: none !important;
                }
                `,
                null,
                null,
            ])}
    `,
}


cartActionsStyles.narrowOverflowMenu={
   
    cssOverrides:{
        menu:css`

           span:first-child{
            padding:0px;
           }
           button{
            text-align: left;
              
                  }
          
        `
    }
}


